export default {"src":"/_next/static/media/wfr-usda-raw-badge.d9fd44e7.svg","height":95,"width":95};